// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  height: 100%;
}

body {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  margin: 0;
}

/* Project and resource dialogs */
label,
input,
select {
  box-sizing: border-box;
  display: block;
  padding-bottom: 0.5em;
}

input.text,
select.text {
  margin-bottom: 1em;
  padding: 0.5em;
  width: 100%;
}

fieldset {
  border: 0;
  margin-top: 1em;
  padding: 0;
}

a,
a:active,
a:focus,
a:visited {
  color: #007eb7;
  outline: 0;
}

a:hover {
  color: #000;
}

.progress {
  box-sizing: border-box;
  padding: 0.5em 0;
}

.logo {
  display: block;
  margin: 0 auto 1em;
  max-height: 20vh;
  max-width: 100%;
}

.ui-dialog {
  left: auto !important;
  margin: auto;
  max-width: 88vw;
  position: relative;
  top: auto !important;
}

.ui-dialog .ui-dialog-titlebar {
  align-items: center;
  font-weight: normal;
}

/* Don't display close button in the top right corner of the box */
.ui-dialog.no-close .ui-dialog-titlebar-close {
  display: none;
}
.ui-dialog-titlebar-close{
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  padding: 0px !important;
}

.ui-dialog .ui-dialog-content {
  margin-top: 1em;
  max-height: calc(100vh - 12em) !important;
  overflow-y: auto;
}

.ui-dialog .ui-dialog-buttonpane {
  /* Avoid padding related overflow */
  box-sizing: border-box;
}

@media only screen and (max-width: 1080px) {
  .ui-dialog .ui-dialog-buttonpane {
    padding-top: 1em;
  }
}

#root.initialized::after {
  display: none;
}

/* Initialisation message for IE11 */
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  #root::after {
    color: #a05000;
    content: "Initializing the experiment... | Internet Explorer / Edge [beta]";
    font-weight: bold;
  }
}
`, "",{"version":3,"sources":["webpack://./psychojs/src/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,SAAS;AACX;;AAEA,iCAAiC;AACjC;;;EAGE,sBAAsB;EACtB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,UAAU;AACZ;;AAEA;;;;EAIE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE;IACE,cAAc;IACd,2EAA2E;IAC3E,iBAAiB;EACnB;AACF","sourcesContent":["html {\n  height: 100%;\n}\n\nbody {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  margin: 0;\n}\n\n/* Project and resource dialogs */\nlabel,\ninput,\nselect {\n  box-sizing: border-box;\n  display: block;\n  padding-bottom: 0.5em;\n}\n\ninput.text,\nselect.text {\n  margin-bottom: 1em;\n  padding: 0.5em;\n  width: 100%;\n}\n\nfieldset {\n  border: 0;\n  margin-top: 1em;\n  padding: 0;\n}\n\na,\na:active,\na:focus,\na:visited {\n  color: #007eb7;\n  outline: 0;\n}\n\na:hover {\n  color: #000;\n}\n\n.progress {\n  box-sizing: border-box;\n  padding: 0.5em 0;\n}\n\n.logo {\n  display: block;\n  margin: 0 auto 1em;\n  max-height: 20vh;\n  max-width: 100%;\n}\n\n.ui-dialog {\n  left: auto !important;\n  margin: auto;\n  max-width: 88vw;\n  position: relative;\n  top: auto !important;\n}\n\n.ui-dialog .ui-dialog-titlebar {\n  align-items: center;\n  font-weight: normal;\n}\n\n/* Don't display close button in the top right corner of the box */\n.ui-dialog.no-close .ui-dialog-titlebar-close {\n  display: none;\n}\n.ui-dialog-titlebar-close{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n  padding: 0px !important;\n}\n\n.ui-dialog .ui-dialog-content {\n  margin-top: 1em;\n  max-height: calc(100vh - 12em) !important;\n  overflow-y: auto;\n}\n\n.ui-dialog .ui-dialog-buttonpane {\n  /* Avoid padding related overflow */\n  box-sizing: border-box;\n}\n\n@media only screen and (max-width: 1080px) {\n  .ui-dialog .ui-dialog-buttonpane {\n    padding-top: 1em;\n  }\n}\n\n#root.initialized::after {\n  display: none;\n}\n\n/* Initialisation message for IE11 */\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  #root::after {\n    color: #a05000;\n    content: \"Initializing the experiment... | Internet Explorer / Edge [beta]\";\n    font-weight: bold;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
